import type { LayoutSettings as CoreLayoutSettings } from '@zhiyue/core';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

type AppLayoutSettings = CoreLayoutSettings & {
  colorPrimary?: string;
  contentWidth?: 'Fluid' | 'Fixed';
  pwa?: boolean;
  title?: string;
  logo?: string;
  token?: Record<string, unknown>;
  splitMenus?: boolean;
};

/**
 * @name
 */
const Settings: AppLayoutSettings = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {},
  splitMenus: false,
};
export default Settings;
